var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center m-4"},[_c('h4',[_vm._v(_vm._s(_vm.code))]),(_vm.code == 404)?_c('p',[_vm._v("This page does not exist")]):_c('p',[_vm._v("An error occured")])])}
var staticRenderFns = []

export { render, staticRenderFns }